var _path, _path2, _path3, _circle, _path4, _path5, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgIcEnq = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 66 66",
    id: "bank-reconciliation",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#FFFFFF",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    strokeWidth: 1.5,
    d: "M9.6 34.3V13.6h32.6v6.5M42.2 50v9.5H24"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#FFFFFF",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    strokeWidth: 1.5,
    d: "M5.1 34.3V12.8c0-2 1.6-3.7 3.7-3.7H15v4.5h21.8V9.1H43c2 0 3.7 1.6 3.7 3.7v8.8m0 29.8v8.9c0 2-1.7 3.7-3.7 3.7H23.7"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#FFFFFF",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    strokeWidth: 1.5,
    d: "M15 7.7v5.9h21.8V7.7c0-1.3-1-2.3-2.3-2.3h-5.2c0 1.9-1.5 3.4-3.4 3.4s-3.4-1.5-3.4-3.4h-5.2c-1.3 0-2.3 1-2.3 2.3z"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 25.9,
    cy: 5.4,
    r: 3.4,
    fill: "none",
    stroke: "#FFFFFF",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    strokeWidth: 1.5
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#FFFFFF",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    strokeWidth: 1.5,
    d: "M5.4 37.1h13.2c1.3 0 2.3 1 2.3 2.3v22.3c0 1.3-1 2.3-2.3 2.3H5.4c-1.3 0-2.3-1-2.3-2.3V39.4c0-1.2 1-2.3 2.3-2.3z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fill: "white",
    stroke: "#FFFFFF",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    strokeWidth: 1.5,
    d: "M17.8 45.506H6.2v-4.7h11.6zM17.84 53.2h-4.2V49h4.2zM10.362 53.2h-4.2V49h4.2zM17.84 60.36h-4.2v-4.2h4.2zM10.362 60.36h-4.2v-4.2h4.2zM15.5 20.7h16.4M15.5 25.8h11.2M15.5 30.9h8.2"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    stroke: "#FFFFFF",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    strokeWidth: 1.5
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 39.5,
    cy: 35,
    r: 11.9,
    transform: "rotate(-36.731 39.53 35.007)"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 39.5,
    cy: 35,
    r: 8.2,
    transform: "rotate(-36.731 39.53 35.007)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M50 40.7s10.5 8.2 11.5 9.2c1.9 1.9 1.9 5.1 0 7-1.9 1.9-5.1 1.9-7 0-1-1-9.2-11.5-9.2-11.5M36.6 35l1.8 1.8 4.7-4.7"
  }))));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgIcEnq);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/ic-enq.4c1e07fca1d928b037b379fe98e6a1ff.svg";